module.exports = __webpack_public_path__ + "assets/media/day2.86909dea.mp3";